// extracted by mini-css-extract-plugin
export var globalCart = "RightMenu_globalCart__kf5Y0";
export var loginPageRightMenuContainer = "RightMenu_loginPageRightMenuContainer__2nhFL";
export var rightMenuContainer = "RightMenu_rightMenuContainer__U5f4Y";